import $ from 'jquery';

export const index = () => {
  const $link = $('.fileDownload');
  if ($link && $link.length) {
    $link[0].click();
  }
};



// WEBPACK FOOTER //
// ./src/modules/customer/index.js